module.exports = __webpack_public_path__ + "static/media/android-download.c912d15b.png";